import { render, staticRenderFns } from "./RowRadioButton.vue?vue&type=template&id=3dee70d6&"
import script from "./RowRadioButton.vue?vue&type=script&lang=js&"
export * from "./RowRadioButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports